import "../styles/header.css";

const Header = function () {
  return <h1 className="nav">404 Not found</h1>;
};

export default Header;
